import { SearchIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Avatar,
  Button,
  Card,
  CardBody,
  CardHeader,
  Flex,
  Heading,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Stack,
} from "@chakra-ui/react";
import * as React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import {
  cairu,
  camamu,
  gandu,
  jiquirica,
  laje,
  marau,
  mutuipe,
  nilopecanha,
  teolandia,
  ubaira,
  ubaitaba,
  valenca,
  wenceslau,
} from "../assets/img/logo_filiais";

export default function FiliaisGrids() {
  const [searchValue, setSearchValue] = useState("");

  const cards = [
    {
      heading: "VALENÇA",
      src: valenca,
      to: "/filial/VALENÇA",
    },
    {
      heading: "CRUZEIRO DE LAJE",
      to: "/filial/CRUZEIRO DE LAJE",
    },
    {
      heading: "GAMBOA",
      to: "/filial/GAMBOA",
    },
    {
      heading: "BARRA GRANDE",
      to: "/filial/BARRA GRANDE",
    },
    {
      heading: "BOIPEBA",
      to: "/filial/BOIPEBA",
    },
    {
      heading: "CAIRU",
      src: cairu,
      to: "/filial/CAIRU",
    },
    {
      heading: "GANDU",
      src: gandu,
      to: "/filial/GANDU",
    },
    {
      heading: "CAMAMU",
      src: camamu,
      to: "/filial/CAMAMU",
    },
    {
      heading: "JIQUIRIÇÁ",
      src: jiquirica,
      to: "/filial/JIQUIRIÇÁ",
    },
    {
      heading: "LAJE",
      src: laje,
      to: "/filial/LAJE",
    },
    {
      heading: "MARAÚ",
      src: marau,
      to: "/filial/MARAÚ",
    },
    {
      heading: "MUTUÍPE",
      src: mutuipe,
      to: "/filial/MUTUÍPE",
    },
    {
      heading: "ITAMARATY",
      to: "/filial/ITAMARATY",
    },

    {
      heading: "PALMA",
      to: "/filial/PALMA",
    },

    {
      heading: "NILO PEÇANHA",
      src: nilopecanha,
      to: "/filial/NILO PEÇANHA",
    },
    {
      heading: "UBAÍRA",
      src: ubaira,
      to: "/filial/UBAÍRA",
    },
    {
      heading: "TEOLÂNDIA",
      src: teolandia,
      to: "/filial/TEOLÂNDIA",
    },
    {
      heading: "WENCESLAU",
      src: wenceslau,
      to: "/filial/WENCESLAU",
    },
    {
      heading: "A Teste",
      to: "/filial/Teste",
    },
    {
      heading: "UBAITABA",
      src: ubaitaba,
      to: "/filial/UBAITABA",
    },
  ];

  cards.sort(function (a, b) {
    if (a.heading > b.heading) {
      return 1;
    }
    if (a.heading < b.heading) {
      return -1;
    }
    // a must be equal to b
    return 0;
  });

  const filteredCards = cards.filter((card) =>
    card.heading.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <>
      <Alert status="info" mb={5} flexDirection={["column", "column", "row"]}>
        <Alert flexDirection="column">
          <AlertIcon />
          <AlertTitle mt={4} mb={1} fontSize="lg">
            Aviso importante!
          </AlertTitle>
        </Alert>
        Estamos realizando uma reformulação completa na plataforma para
        aprimorar a sua usabilidade e fornecer funcionalidades ainda mais úteis.
        Nesta atualização, serão adicionadas abas dedicadas a documentos,
        métricas de consumo mais precisas e relatórios detalhados e específicos
        para otimizar a sua experiência. Pedimos gentilmente que tenham
        paciência e aguardem a finalização desta atualização, pois ela será
        fundamental para melhorar a sua utilização da plataforma.
      </Alert>

      <InputGroup mb={3} mt={-1}>
        <InputLeftElement
          pointerEvents="none"
          children={<SearchIcon color="gray.300" />}
        />
        <Input
          type="text"
          placeholder="Pesquise o nome da filial"
          onChange={(e) => setSearchValue(e.target.value)}
          variant="filled"
        />
      </InputGroup>
      <SimpleGrid
        spacing={3}
        templateColumns="repeat(auto-fill, minmax(200px, 1fr))"
      >
        {filteredCards.map(({ heading, src, to }, index) => (
          <Flex key={index} justifyContent="center" alignItems={"center"}>
            <Card
              key={index}
              justifyContent="center"
              alignItems={"center"}
              width={325}
              height={300}
              boxShadow="lg"
              rounded="lg"
            >
              <CardHeader>
                <Heading size="md" mb={-10}>
                  {heading}
                </Heading>
              </CardHeader>
              <CardBody justifyContent="center" alignItems={"center"}>
                {src ? ( //
                  <Image
                    src={src}
                    alt={heading}
                    borderRadius="lg"
                    width={150}
                    height={150}
                  />
                ) : (
                  <Avatar name={heading} width={150} height={150} />
                )}
                <Stack mt="3" spacing="3"></Stack>
                <Link to={to}>
                  <Button
                    variant="solid"
                    colorScheme="blue"
                    width={"100%"}
                    justifyContent="center"
                    alignItems={"center"}
                  >
                    Acessar
                  </Button>
                </Link>
              </CardBody>
            </Card>
          </Flex>
        ))}
      </SimpleGrid>
    </>
  );
}
